import { FormInstance, message } from "antd";

export interface IOnConfirmDrawerUpdateReader {
  formReader: FormInstance<any>;
  formAntenna: FormInstance<any>;
  messageDescription: string;
  readersAntennaUpdatedAsync: (...args) => void;
}

export const onConfirmDrawerUpdateReaderAntenna = async ({ formReader, formAntenna, readersAntennaUpdatedAsync, messageDescription }: IOnConfirmDrawerUpdateReader) => {
  try {
    await Promise.all([formReader.validateFields(), formAntenna.validateFields()]);

    readersAntennaUpdatedAsync();
  } catch (e) {
    message.error(messageDescription);
  }
};
